import React, { memo, useMemo } from 'react';
import _keyBy from 'lodash/keyBy';

import useToggle from '@lyearn/core/hooks/useToggle';
import { useTranslation } from '@lyearn/i18n';
import { UserEntityConfig } from '@/components/FilterManager/EntityFilter/entity/user';
import EntityFilter from '@/components/Filters/EntityFilter';
import { TagSubTypeEnum } from '@/types/schema';

import { UserTagValue } from '../../types';
import MenuActionButton from './MenuActionButton';
import { TagsValueSelectorProps } from './types';
import { getUserTagTypePlaceholder } from './utils';

const EMPTY_ARRAY = Object.freeze([]);

function UserSelect(props: TagsValueSelectorProps) {
  const { t } = useTranslation();
  const { className, tag, selectedTagValue, onChange, onDelete, error, readOnly, children } = props;
  const [isOpen, { toggle: onToggle }] = useToggle(false);
  const userValues = (selectedTagValue || EMPTY_ARRAY) as UserTagValue;

  const { tagValuesStore, selectedValues, selectedTagValues } = useMemo(
    () => ({
      tagValuesStore: _keyBy(userValues, 'id'),
      selectedValues: userValues!.map((val) => val.value),
      selectedTagValues: getUserTagTypePlaceholder(userValues),
    }),
    [userValues],
  );

  return (
    <EntityFilter
      initialSelectedOptions={selectedValues}
      listConfig={{
        ...UserEntityConfig,
        listVariant:
          tag.subType === TagSubTypeEnum.SingleSelect
            ? 'single-ungrouped-infinite'
            : UserEntityConfig.listVariant,
      }}
      open={isOpen}
      tagValuesStore={tagValuesStore}
      uiConfig={{
        showActionButtons: false,
      }}
      onChange={onChange}
      onToggle={onToggle}>
      {children || (
        <MenuActionButton
          className={className}
          count={selectedTagValues?.count}
          defaultPlaceholder={t('Tags:Form.SelectUsers')}
          error={error}
          readOnly={readOnly}
          selectedTagValue={selectedTagValues?.text}
          tag={tag}
          onDelete={onDelete}
        />
      )}
    </EntityFilter>
  );
}

export default memo(UserSelect);
